<template>
    <transition name="uimask">
        <div class="mask" v-show="_ShowMask"></div>
    </transition>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: "uimask",
        computed:{
            ...mapGetters(['_ShowMask'])
        }
    }
</script>

<style lang="scss" scope>
    .mask {
        position: fixed;
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;
        background: rgba(0,15,23,.5);
        z-index: 101;
        opacity: 1;
        transition: all .3s;
    }
    .uimask-enter, .uimask-leave-active {
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/uimask.vue